import React, { useState } from "react";
import Modal from "../../components/modals/ModalBoth";
import {
  ButtonClose,
  Button,
  ContainerModal,
  InputContainer,
  ModalTitle,
  Content,
} from "./OlvidoClaveElements";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import {
  selectForgotPasswordModal,
  setShowForgotPassword,
} from "../../features/modals/modalsSlice";
import axios from "axios";
import { API_URL } from "../../const/api";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { errorNotification } from "../../utils/toastNotifications";
import { useTranslation } from "react-i18next";

const OlvidoClave = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const claveModal = useSelector(selectForgotPasswordModal);
  const [t] = useTranslation("global");

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setLoading(false);
    setEmail("");
    dispatch(setShowForgotPassword(false));
  };

  const sendEmail = async () => {
    if (email !== "") {
      setLoading(true);
      const res = await axios.post(API_URL + "verificarCorreo", {
        correo: email,
      });
      if (res.data.status === 1) {
        if (res.data.response) {
          Swal.fire({
            html:
              `<h3>${t("modal-reset-pass.title")}</h3>` +
              `<p class="register-p"><b>${t("modal-reset-pass.info")}</b></p>` +
              `<small style="text-align: center; display: block;">${t("modal-reset-pass.small")}</small>` +
              `<p style="margin: 1rem 0; font-size: 0.9rem; color: #fff; font-weight:bold; ">${t("modal-reset-pass.chatenlinea")}</p>` +
               `<p style="margin: 0; font-size: 0.8rem">Telegram: <a padding="0.5rem;" href="https://t.me/MasterBets365bot" target="_blank">${t(
                "modal-reset-pass.btn"
              )}</a></p>` +
              `<p style="margin: 0.8rem; font-size: 0.8rem">${t(
                "modal-reset-pass.email"
              )}: mastbets365@gmail.com</p>`,
            icon: "success",
            background: SECONDARY,
            color: "#fff",
            confirmButtonColor: PRIMARY,
          });
          handleClose();
        } else {
          setLoading(false);
          errorNotification(
            t('alert.errorNotificationRetiro-50')
          );
        }
      } else {
        setLoading(false);
        errorNotification(t('alert.errorNotificationRetiro-51'));
      }
    } else {
      errorNotification(t('alert.errorNotificationRetiro-52'));
    }
  };

  return (
    <Modal
      open={claveModal}
      maxWidth="sm"
      fullWidth={false}
      handleClose={handleClose}
      children={
        <ContainerModal>
          <ModalTitle>
            <h2>{t('contact.lbl-pass')}</h2>
            <ButtonClose onClick={handleClose}>
              <CloseIcon />
            </ButtonClose>
          </ModalTitle>
          <Content>
            <InputContainer>
              <label>{t('contact.lbl-email')}</label>
              <input
                placeholder={t('contact.lbl-Registered')}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputContainer>
            <Button
              disabled={email === "" || loading ? true : false}
              onClick={sendEmail}
            >
              {loading ? t('buttons.send') : t('contact.btn-send')}
            </Button>
          </Content>
        </ContainerModal>
      }
    />
  );
};

export default OlvidoClave;
